module.exports = __webpack_public_path__ + "static/img/autokatalog.6fac224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404_page/teaser/autokatalog.jpg
// module id = rGxN
// module chunks = 1